import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";

function ReporteEmbarques() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);
  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedContenedor, setSelectedContenedor] = useState("");
  const [selectedEstado, setSelectedEstado] = useState("");

  // Pagination
  const [comments, setComments] = useState([]);
  const [contenedores, setContenedores] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(URL_ARTICULOS_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const all = response.data;
        const arrayTabla = all
          .sort((a, b) =>
            (a.embarques?.[0]?.idEmbarques || 0) <
            (b.embarques?.[0]?.idEmbarques || 0)
              ? 1
              : -1
          )
          .map((a) => {
            const pedido = Number(a.cantidad) || 0;
            const recibido = Number(a.recibido) || 0;
            const pendiente =
              a.pendiente_recibir != null
                ? Number(a.pendiente_recibir)
                : pedido - recibido;
            return {
              _id: a._id,
              embarque: a.embarques?.[0]?.idEmbarques || "",
              contenedor: a.embarques?.[0]?.contenedor || "",
              fecha: a.embarques?.[0]?.fechaEmbarque || "",
              recibidoEmbarque: a.embarques?.[0]?.recibido || "",
              SKU: a.articulos?.[0]?.SKU || "",
              articulo: a.articulos?.[0]?.nombre || "",
              proveedor: a.proveedores?.[0]?.nombre_comercial || "",
              pedido,
              recibidoCant: recibido,
              pendiente,
            };
          })
          .filter((el) => el != null);

        setComments(arrayTabla);

        // Lista de contenedores unicos para el filtro
        const cont = [
          ...new Set(arrayTabla.map((r) => r.contenedor).filter(Boolean)),
        ].sort();
        setContenedores(cont);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const headers = [
    { name: "Embarque", field: "embarque", sortable: true },
    { name: "Contenedor", field: "contenedor", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Articulo", field: "articulo", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: "Embarcado", field: "pedido", sortable: true },
    { name: "Recibido", field: "recibidoCant", sortable: true },
    { name: "Pendiente", field: "pendiente", sortable: true },
  ];

  const numericos = ["embarque", "pedido", "recibidoCant", "pendiente"];

  const commentsData = useMemo(() => {
    let computed = comments;

    if (search) {
      const s = search.toLowerCase();
      computed = computed.filter(
        (c) =>
          c.contenedor.toLowerCase().includes(s) ||
          c.SKU.toLowerCase().includes(s) ||
          c.articulo.toLowerCase().includes(s) ||
          c.proveedor.toLowerCase().includes(s) ||
          c.embarque.toString().includes(search)
      );
    }
    if (selectedContenedor) {
      computed = computed.filter((c) => c.contenedor === selectedContenedor);
    }
    if (selectedEstado === "Pendiente") {
      computed = computed.filter((c) => Number(c.pendiente) > 0);
    }
    if (selectedEstado === "Completo") {
      computed = computed.filter((c) => Number(c.pendiente) <= 0);
    }
    if (selectedFechaInicio) {
      computed = computed.filter((c) => c.fecha >= selectedFechaInicio);
    }
    if (selectedFechaFin) {
      computed = computed.filter((c) => c.fecha <= selectedFechaFin);
    }

    setTotalItems(computed.length);

    if (sorting.field && !numericos.includes(sorting.field)) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computed = [...computed].sort(
        (a, b) =>
          reversed *
          (a[sorting.field] || "")
            .toString()
            .localeCompare((b[sorting.field] || "").toString())
      );
    }
    if (sorting.field && numericos.includes(sorting.field)) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computed = [...computed].sort(
        (a, b) =>
          reversed *
          ((parseFloat(a[sorting.field]) || 0) -
            (parseFloat(b[sorting.field]) || 0))
      );
    }

    return computed.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedContenedor,
    selectedEstado,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  // Aplica los mismos filtros (sin paginar) para exportar
  function dataFiltrada() {
    return comments.filter((c) => {
      const s = search.toLowerCase();
      const okSearch =
        !search ||
        c.contenedor.toLowerCase().includes(s) ||
        c.SKU.toLowerCase().includes(s) ||
        c.articulo.toLowerCase().includes(s) ||
        c.proveedor.toLowerCase().includes(s) ||
        c.embarque.toString().includes(search);
      const okCont = !selectedContenedor || c.contenedor === selectedContenedor;
      const okEstado =
        !selectedEstado ||
        (selectedEstado === "Pendiente" && Number(c.pendiente) > 0) ||
        (selectedEstado === "Completo" && Number(c.pendiente) <= 0);
      const okFecha =
        (!selectedFechaInicio || c.fecha >= selectedFechaInicio) &&
        (!selectedFechaFin || c.fecha <= selectedFechaFin);
      return okSearch && okCont && okEstado && okFecha;
    });
  }

  function PDFTabla() {
    const data = dataFiltrada().map((a) => [
      a.embarque,
      a.contenedor,
      a.fecha,
      a.SKU,
      a.articulo,
      a.proveedor,
      new Intl.NumberFormat("en-US").format(a.pedido),
      new Intl.NumberFormat("en-US").format(a.recibidoCant),
      new Intl.NumberFormat("en-US").format(a.pendiente),
    ]);
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 8, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 5, 30, 30);
    doc.text(`Reporte Embarques (Embarcado vs Recibido)`, 20, 20);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 28);
    doc.autoTable({
      head: [
        [
          "Embarque",
          "Contenedor",
          "Fecha",
          "SKU",
          "Articulo",
          "Proveedor",
          "Embarcado",
          "Recibido",
          "Pendiente",
        ],
      ],
      body: data,
      startY: 34,
    });
    doc.save(`ReporteEmbarques.pdf`);
  }

  function excel() {
    const dataExcel = dataFiltrada().map((a) => ({
      Embarque: a.embarque,
      Contenedor: a.contenedor,
      Fecha: a.fecha,
      SKU: a.SKU,
      Articulo: a.articulo,
      Proveedor: a.proveedor,
      Embarcado: a.pedido,
      Recibido: a.recibidoCant,
      Pendiente: a.pendiente,
    }));
    const option = {};
    option.fileName = "ReporteEmbarques";
    option.datas = [
      {
        sheetData: dataExcel,
        sheetName: "ReporteEmbarques",
        sheetFilter: [
          "Embarque",
          "Contenedor",
          "Fecha",
          "SKU",
          "Articulo",
          "Proveedor",
          "Embarcado",
          "Recibido",
          "Pendiente",
        ],
        sheetHeader: [
          "Embarque",
          "Contenedor",
          "Fecha",
          "SKU",
          "Articulo",
          "Proveedor",
          "Embarcado",
          "Recibido",
          "Pendiente",
        ],
      },
    ];
    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button size="sm" className="btn" color="danger" onClick={PDFTabla}>
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button size="sm" className="btn" color="primary" onClick={excel}>
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align="center">Reporte Embarques (Embarcado vs Recibido)</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => setSelectedFechaInicio(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                onChange={(e) => setSelectedFechaFin(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Contenedor</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedContenedor}
                onChange={(e) => {
                  setSelectedContenedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                {contenedores.map((c) => (
                  <option value={c}>{c}</option>
                ))}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Estado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEstado}
                onChange={(e) => {
                  setSelectedEstado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Pendiente">Pendiente por recibir</option>
                <option value="Completo">Recibido completo</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => (
                <tr key={a._id}>
                  <td>{a.embarque}</td>
                  <td>{a.contenedor}</td>
                  <td style={{ minWidth: 100 }}>{a.fecha}</td>
                  <td>{a.SKU}</td>
                  <td>{a.articulo}</td>
                  <td>{a.proveedor}</td>
                  <td>{new Intl.NumberFormat("en-US").format(a.pedido)}</td>
                  <td>{new Intl.NumberFormat("en-US").format(a.recibidoCant)}</td>
                  <td
                    style={{
                      fontWeight: 700,
                      color: Number(a.pendiente) > 0 ? "#b91c1c" : "#15803d",
                    }}
                  >
                    {new Intl.NumberFormat("en-US").format(a.pendiente)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ fontWeight: 700, borderTop: "2px solid #cbd5e1" }}>
                <td colSpan={6} className="text-right">
                  Totales
                </td>
                <td>
                  {new Intl.NumberFormat("en-US").format(
                    dataFiltrada().reduce((a, r) => a + (Number(r.pedido) || 0), 0)
                  )}
                </td>
                <td>
                  {new Intl.NumberFormat("en-US").format(
                    dataFiltrada().reduce(
                      (a, r) => a + (Number(r.recibidoCant) || 0),
                      0
                    )
                  )}
                </td>
                <td>
                  {new Intl.NumberFormat("en-US").format(
                    dataFiltrada().reduce(
                      (a, r) => a + (Number(r.pendiente) || 0),
                      0
                    )
                  )}
                </td>
              </tr>
            </tfoot>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ReporteEmbarques;
